import { useMemo } from "react";
import { StepsLayout } from "@covertree/layouts";
import { useCurrentStepDetails } from "@covertree/layouts/StepsLayout/utils/useCurrentStepDetails";
import { steps } from "@routing/steps";
import { StepPath } from "@routing/paths";
import { CONTACT_PHONE_NUMBER } from "@consts/index";
import { useResetFlowWhenNoData } from "../../hooks/useResetFlowWhenNoData";

export function AppProvider() {
  useResetFlowWhenNoData();

  const rootStepPath = StepPath.POLICY_DETAILS;
  const stepsWithoutBackButton = [StepPath.POLICY_DETAILS];
  const currentStep = useCurrentStepDetails(steps, rootStepPath);

  const pageTitle = useMemo(() => currentStep.title, [currentStep]);
  const showErrorIcon = useMemo(() => currentStep.isErrorPage, [currentStep]);
  const showBackButton = useMemo(
    () => !stepsWithoutBackButton.includes(currentStep.path),
    [currentStep]
  );

  return (
    <StepsLayout
      steps={steps}
      currentStep={currentStep}
      pageTitle={pageTitle}
      contactNumber={CONTACT_PHONE_NUMBER}
      contentWidth="800px"
      errorIcon="/images/icons/cross.webp"
      showErrorIcon={showErrorIcon}
      showBackButton={showBackButton}
      showDisclaimerMessage={false}
    />
  );
}
